/* Southern Standard — reveal, sticky header, mobile menu, cart drawer.
   Uses the COMP'S conventions ([data-reveal] + .shown) so the ported CSS works
   unchanged. Everything degrades: the drawers are server-rendered, checkout is
   a real form POST, the Bag link keeps its /cart href and every menu entry is a
   plain <a>, so nothing here is load-bearing if the JS fails. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ----------
     [data-reveal] starts at opacity 0, so ANY failure to add .shown leaves the
     content invisible. On a hero that is catastrophic, so this is deliberately
     belt-and-braces:

       1. Anything already in the viewport is shown IMMEDIATELY. Above-the-fold
          content never waits on IntersectionObserver.
       2. The observer only handles what is genuinely below the fold.
       3. visibilitychange re-runs the pass. IntersectionObserver does NOT fire
          while document.hidden is true, so a page opened in a BACKGROUND TAB
          (cmd-click, "open in new tab", a browser restoring tabs at startup)
          would otherwise sit completely blank until the visitor scrolled.
          Observed on a real page, not theorised.
       4. A 2.5s timer reveals anything still hidden, whatever went wrong.

     If the opacity:0 default is ever removed, all of this can go. */

  function showAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('shown');
  }

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.top < (window.innerHeight || 0) && r.bottom > 0;
  }

  var io = null;

  function initReveal() {
    var t = document.querySelectorAll('[data-reveal]:not(.shown)');
    if (!t.length) return;

    if (reduced || !('IntersectionObserver' in window)) { showAll(t); return; }

    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('shown');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    }

    for (var i = 0; i < t.length; i++) {
      if (inViewport(t[i])) t[i].classList.add('shown');
      else io.observe(t[i]);
    }
  }

  function revealEverything() {
    showAll(document.querySelectorAll('[data-reveal]:not(.shown)'));
  }

  /* ---------- sticky header ---------- */
  function stickyHeader() {
    var hdr = document.getElementById('hdr');
    if (!hdr || hdr.dataset.ssStuckBound) return;
    hdr.dataset.ssStuckBound = '1';
    function onScroll() {
      if (window.scrollY > 12) hdr.classList.add('is-stuck');
      else hdr.classList.remove('is-stuck');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile menu ----------
     The comp hid the nav on small screens and put nothing in its place, so a
     phone had no route to Our Story or Contact except the footer.

     Every link inside is a real <a>, so with JS off the drawer simply never
     opens — it does not trap anyone. Focus moves to the close button on open
     and back to the burger on close, and Escape closes, so it is keyboard
     operable rather than mouse-only. */
  function bindNav() {
    var burger = document.getElementById('ssBurger');
    var nav = document.getElementById('ss-nav');
    var overlay = document.getElementById('ss-nav-overlay');
    if (!burger || !nav || burger.dataset.ssNavBound) return;
    burger.dataset.ssNavBound = '1';

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      if (overlay) overlay.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      // Lock the page behind the drawer so the body does not scroll under it.
      document.documentElement.classList.toggle('ss-nav-open', open);
      if (open) {
        var x = nav.querySelector('.ss-nav__x');
        if (x) x.focus();
      } else {
        burger.focus();
      }
    }

    burger.addEventListener('click', function () {
      setOpen(!nav.classList.contains('is-open'));
    });

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('[data-ss-nav-close]')) { e.preventDefault(); setOpen(false); }
      // Following a link should close it, otherwise the drawer is still open
      // behind the new page on a browser back-navigation restore.
      else if (e.target.closest('#ss-nav a')) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) setOpen(false);
    });

    // Rotating a phone to landscape can cross the desktop breakpoint, where the
    // drawer is display:none — leaving the scroll lock stuck on with no way to
    // clear it. Close on any resize past the breakpoint.
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900 && nav.classList.contains('is-open')) setOpen(false);
    });
  }

  /* ---------- cart drawer ---------- */
  // Storefront is USD; Shopify's money filter renders $X.XX, so match it.
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function drawer() { return document.getElementById('ss-drawer'); }

  function openCart() {
    var d = drawer(), o = document.getElementById('ss-cart-overlay');
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    if (o) o.classList.add('is-open');
  }

  function closeCart() {
    var d = drawer(), o = document.getElementById('ss-cart-overlay');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (o) o.classList.remove('is-open');
  }

  // Shopify answers an over-stock request with 422 and {status, description} —
  // NOT a cart object. Painting that blanks the drawer while the item is still
  // in the cart, which reads as "my bag emptied itself". Christa stocks 1-3 of
  // each size, so shoppers WILL hit this. Treat any response without
  // item_count as an error: show why, then repaint from the real cart.
  function isCart(res) { return res && typeof res.item_count !== 'undefined'; }

  function notify(text) {
    var el = document.getElementById('ss-cart-msg');
    if (!el) return;
    if (!text) { el.hidden = true; el.textContent = ''; return; }
    el.textContent = text;
    el.hidden = false;
  }

  function lineHTML(item) {
    var img = item.image
      ? "background-image:url('" + item.image + "')"
      : 'background:linear-gradient(160deg,#EFE5DF,#E3D3CB)';
    var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
      ? '<div class="ss-drawer__variant">' + item.variant_title + '</div>' : '';
    var cat = item.product_type
      ? '<div class="cat-name ss-drawer__cat">' + item.product_type + '</div>' : '';
    return '<div class="ss-drawer__line" data-ss-key="' + item.key + '">'
      + '<a href="' + item.url + '" class="ss-drawer__thumb" style="' + img + '"></a>'
      + '<div class="ss-drawer__meta">' + cat
      + '<div class="prod-name ss-drawer__name">' + item.product_title + '</div>' + variant
      + '<div class="ss-drawer__qtyrow">'
      + '<button type="button" class="ss-drawer__step" data-ss-qty="' + item.key + '" data-ss-delta="-1" aria-label="Decrease quantity">−</button>'
      + '<span class="ss-drawer__q">' + item.quantity + '</span>'
      + '<button type="button" class="ss-drawer__step" data-ss-qty="' + item.key + '" data-ss-delta="1" aria-label="Increase quantity">+</button>'
      + '<span class="ss-drawer__lp">' + money(item.line_price) + '</span>'
      + '</div></div></div>';
  }

  function paint(cart) {
    if (!isCart(cart)) return; // never blank the drawer on an error payload
    var box = document.getElementById('ss-cart-items');
    if (box) {
      box.innerHTML = cart.item_count
        ? cart.items.map(lineHTML).join('')
        : '<div class="ss-drawer__empty">Your bag is empty.</div>';
    }
    var q = document.getElementById('ss-cart-qty');
    if (q) q.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    var s = document.getElementById('ss-cart-subtotal');
    if (s) s.textContent = money(cart.total_price);
    var co = document.querySelector('.ss-drawer__checkout');
    if (co) co.disabled = cart.item_count === 0;

    var badge = document.getElementById('cartCount');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.classList.toggle('is-on', cart.item_count > 0);
    }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paint);
  }

  // Any cart write funnels through here so the error path is identical.
  function apply(res) {
    if (isCart(res)) { notify(null); paint(res); return; }
    notify((res && (res.description || res.message)) || 'That did not go through — please try again.');
    return refresh();
  }

  function bindCart() {
    if (document.body.dataset.ssCartBound) return;
    document.body.dataset.ssCartBound = '1';

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      if (t.closest('[data-ss-cart-close]')) { e.preventDefault(); closeCart(); return; }

      // The Bag link keeps href="/cart" as the no-JS fallback; intercept it here.
      if (t.closest('.ss-hdr__bag') && drawer()) { e.preventDefault(); notify(null); openCart(); return; }

      var step = t.closest('[data-ss-qty]');
      if (step) {
        e.preventDefault();
        var line = step.closest('.ss-drawer__line');
        var current = parseInt(line.querySelector('.ss-drawer__q').textContent, 10) || 0;
        var next = current + parseInt(step.getAttribute('data-ss-delta'), 10);
        if (next < 0) next = 0;
        post('/cart/change.js', { id: step.getAttribute('data-ss-qty'), quantity: next })
          .then(apply)
          .catch(function () { window.location.href = '/cart'; });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });

    // Product form -> add without leaving the page, then reveal the bag.
    var form = document.getElementById('ssPdpForm');
    if (form) {
      form.addEventListener('submit', function (e) {
        var id = form.querySelector('#ssPdpVariant');
        if (!id || !drawer()) return; // let the normal POST happen
        e.preventDefault();
        post('/cart/add.js', { id: Number(id.value), quantity: 1 })
          .then(function (res) {
            // add.js returns the LINE ITEM, not the cart, so always refresh.
            if (res && res.status && res.status !== 200) {
              notify(res.description || res.message);
            } else {
              notify(null);
            }
            return refresh();
          })
          .then(openCart)
          .catch(function () { form.submit(); }); // fall back to a real POST
      });
    }
  }

  /* ---------- boot ---------- */
  function boot() { initReveal(); stickyHeader(); bindNav(); bindCart(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Tab was in the background at load: the observer never ran. Re-check.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) initReveal();
  });
  window.addEventListener('pageshow', initReveal);

  // Last resort. Whatever failed, nothing stays invisible.
  setTimeout(revealEverything, 2500);

  // The theme editor swaps section HTML in without a page load. Without this,
  // sections rendered while Christa is editing sit at opacity 0 — looking
  // exactly like we broke her store.
  document.addEventListener('shopify:section:load', boot);

  // Quick-view button sits inside the card link; send it to the product rather
  // than letting the click bubble twice.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ss-quick-url]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = b.getAttribute('data-ss-quick-url');
  });
})();
